/** Payload of the `getSearchedDocumentations` message (UI -> service worker). */
export interface SearchedDocumentationsRequestData {
  searchPhrase: string;
  /**
   * Background refresh of an active search: skip the API resync the service
   * worker runs after a user search (no HTTP sync, filter caches kept).
   */
  skipResync?: boolean;
}

export function shouldResyncAfterSearch(
  data: Pick<SearchedDocumentationsRequestData, 'skipResync'> | undefined
): boolean {
  return !data?.skipResync;
}
